import React from 'react';

import GrowthSectionUnicorn from '../../../assets/svg-components/growth/purple_section_comments_unicorn_.svg';
import GrowthSectionOrnament from '../../../assets/svg-components/growth/purple_section_side_elements.svg';
import GrowthSectionSideElements from '../../../assets/svg-components/growth/purple_sectoin_bottom_2_elements_detail.svg';
import { SectionContent } from '../../../components/section/section-content';
import { SectionHero } from '../../../components/section/section-hero';
import { SectionTitle } from '../../../components/section/section-title';
import { SvgWithGenericAnimation } from '../../../components/svg-with-generic-animation/svg-with-generic-animation';
import { Translate } from '../../../components/translate';
import { LANGUAGES } from '../../../constants/languages';
import { StoreContext } from '../../../store/store';
import { GrowthCard } from './components/card/growth-card';
import { Quotes } from './components/quotes/quotes';
import SocialIcons from './components/social-icons/social-icons';
import { VideoSection } from './components/videos/videos';
import './growth-section.scss';

interface GrowthSectionProps {
  domain?: string;
}

export const GrowthSection: React.FC<GrowthSectionProps> = ({ domain }) => {
  const { state } = React.useContext(StoreContext);
  const lang = state.config.language;

  const showMediaOrIcons = [LANGUAGES.EN, LANGUAGES.DE, LANGUAGES.FR].includes(lang);

  return (
    <React.Fragment>
      <SectionHero className="rc-growth-section rc-growth-section-hero">
        <img src="https://www.siteground.com/static/en/img/recap2023/04_BG.png" alt="growth section image" />

        <SectionTitle>
          <Translate id="translate.growth.section.title" />
        </SectionTitle>

        <GrowthSectionOrnament className="rc-growth-section-hero__ornament rc-growth-section-hero__ornament--top" />
        <GrowthSectionOrnament className="rc-growth-section-hero__ornament rc-growth-section-hero__ornament--bottom" />
      </SectionHero>

      <SectionContent className="rc-growth-section">
        <GrowthCard
          reverted
          icon={<SvgWithGenericAnimation name="email-marketing" />}
          title={<Translate id="translate.growth.card.email.marketing.title" />}
          text={
            domain ? (
              <Translate id="translate.personal.growth.card.email.marketing.text" />
            ) : (
              <Translate id="translate.growth.card.email.marketing.text" />
            )
          }
        />

        <GrowthCard
          icon={<SvgWithGenericAnimation name="start-your-business" />}
          title={<Translate id="translate.growth.card.start.you.business.title" />}
          text={<Translate id="translate.growth.card.start.you.business.text" />}
        >
          <Quotes />
          <GrowthSectionUnicorn className="rc-growth-section__unicorn" width="220" />
        </GrowthCard>

        <GrowthCard
          icon={<SvgWithGenericAnimation name="social" />}
          title={<Translate id="translate.growth.card.social.title" />}
          text={<Translate id="translate.growth.card.social.text" />}
        >
          {showMediaOrIcons ? <VideoSection lang={lang} /> : <SocialIcons lang={lang} />}
          <GrowthSectionSideElements className="rc-growth-section__side-elements" />
        </GrowthCard>
      </SectionContent>
    </React.Fragment>
  );
};
